import {AxiosRequestConfig} from 'axios';

import {getAuthToken} from '../../utils';
import {APIServiceImpl} from '../api';

export interface LocationSuggestion {
  description: string;
  placeId: string;
}

export class PlacesServiceImpl extends APIServiceImpl {
  static readonly AUTOCOMPLETE = '/places/autocomplete';

  constructor() {
    super();
    this.service.interceptors.request.use(config => {
      const token = getAuthToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
  }

  // City/region suggestions for location inputs. Returns [] for short queries or on error.
  async autocompleteLocations(query: string): Promise<LocationSuggestion[]> {
    const trimmed = query.trim();
    if (trimmed.length < 2) {
      return [];
    }
    try {
      const config: AxiosRequestConfig = {params: {q: trimmed}};
      const {data} = await this.get(PlacesServiceImpl.AUTOCOMPLETE, config);
      if (!Array.isArray(data)) {
        return [];
      }
      return data
        .map((item: {description?: string; placeId?: string}) => ({
          description: item.description ?? '',
          placeId: item.placeId ?? '',
        }))
        .filter(suggestion => suggestion.description);
    } catch {
      return [];
    }
  }
}
